export default __webpack_public_path__ + "static/media/wel2.10d36ecf.png";